module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="phx-block">\r\n  <div class="phx-block-title">\r\n    <span class="phx-block-title-icon phx-icon phx-icon-triangle-e" style="display:inline-table;">&nbsp;</span>\r\n    <span class="phx-block-title-text"></span>\r\n  </div>\r\n  <div class="phx-block-content" style="display: none;">&nbsp;<br></div>\r\n</div>\r\n';
}
return __p;
};
